import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("delete")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Delete Selected", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("add")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("edit")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_fab = _resolveComponent("ui-fab")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_pagination = _resolveComponent("ui-pagination")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_zero_state = _resolveComponent("zero-state")!
  const _component_ui_card_media = _resolveComponent("ui-card-media")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_ui_dialog_content = _resolveComponent("ui-dialog-content")!
  const _component_ui_dialog_actions = _resolveComponent("ui-dialog-actions")!
  const _component_ui_dialog = _resolveComponent("ui-dialog")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!

  return (_openBlock(), _createBlock(_component_page_wrapper, null, {
    default: _withCtx(() => [
      (!_ctx.isSubRoute)
        ? (_openBlock(), _createBlock(_component_ui_grid_cell, {
            key: 0,
            class: "bts-wrapper",
            columns: "12"
          }, {
            default: _withCtx(() => [
              (_ctx.selectedRows.length > 1)
                ? (_openBlock(), _createBlock(_component_ui_fab, {
                    key: 0,
                    extended: "",
                    class: "btn-delete-all btn--inline",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDeleteSelectedRows(_ctx.selectedRows)))
                  }, {
                    before: _withCtx(({ iconClass }) => [
                      _createVNode(_component_ui_icon, {
                        class: _normalizeClass(iconClass)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ui_fab, {
                extended: "",
                class: "btn-create-item btn--inline",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onModalOpen('Create')))
              }, {
                before: _withCtx(({ iconClass }) => [
                  _createVNode(_component_ui_icon, {
                    class: _normalizeClass(iconClass)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.isSubRoute)
        ? (_openBlock(), _createBlock(_component_ui_grid_cell, {
            key: 1,
            columns: "12"
          }, {
            default: _withCtx(() => [
              (_ctx.tableData.length)
                ? (_openBlock(), _createBlock(_component_ui_table, {
                    key: 0,
                    modelValue: _ctx.selectedRows,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedRows) = $event)),
                    fullwidth: "",
                    data: _ctx.tableData,
                    thead: _ctx.thead,
                    tbody: _ctx.tbody,
                    "row-checkbox": "",
                    "selected-key": "id"
                  }, {
                    actions: _withCtx(({ data }) => [
                      _createVNode(_component_ui_icon, {
                        class: "icon--hover",
                        onClick: ($event: any) => (_ctx.editRow(data))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_ui_icon, {
                        class: "icon--hover",
                        onClick: ($event: any) => (_ctx.deleteRow(data))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_ui_pagination, {
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
                        total: _ctx.getUsersLength,
                        "show-total": ""
                      }, null, 8, ["modelValue", "total"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "data", "thead", "tbody"]))
                : (_openBlock(), _createBlock(_component_ui_card, {
                    key: 1,
                    outlined: "",
                    class: "card card--zero-state"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ui_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ui_grid_cell, { columns: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ui_card_media, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_zero_state)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ui_grid_cell, { columns: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_ui_dialog, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.open) = $event)),
        onConfirm: _ctx.onConfirm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ui_dialog_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.actionType), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ui_dialog_content, null, {
            default: _withCtx(() => [
              _createElementVNode("p", null, "Do you want to " + _toDisplayString(_ctx.actionType.toLowerCase()) + " item?", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ui_dialog_actions)
        ]),
        _: 1
      }, 8, ["modelValue", "onConfirm"])
    ]),
    _: 1
  }))
}